export default __webpack_public_path__ + "05eb2ae3e508ac45b5a86666c8a1f1d2.png";